module.exports = __webpack_public_path__ + "static/media/kinkhao_03_thumb_hover.d95b7d08.png";